import { requestJSON } from '../../../NonReact/common/API/REST/RESTClient'
import { RouteAccessibilityDTO } from '../../../ReactRouting/Types/Types'
import { ROUTE_URL } from '../../../NonReact/constants/ApiConstants'
import { RESTMethods } from '../../../NonReact/constants/REST'
import { getQueryParamsAsObject } from '../../../NonReact/utils/LocationUtils'
import { RouteID } from '../../../ReactRouting/Components/Molecules/Header/Types/Types'

/**
 * Checks the availability of a route by making a POST request to the server with the route as the payload.
 * The server responds with the accessibility status of the route, which is returned as a Promise that resolves to a RouteAccessibilityDTO or null if the route is not found.
 *
 * @param route - The route to check for availability (e.g., "insights", "cxScore").
 */
export const getRouteAvailability = (route: RouteID): Promise<Nullable<RouteAccessibilityDTO>> => {
    const queryParams: Record<string, string> = getQueryParamsAsObject()

    return requestJSON<RouteAccessibilityDTO>(ROUTE_URL.appendQueryParams(queryParams), {
        method: RESTMethods.POST,
        __INTENTIONALLY_CACHE_NON_GET__: true,
        body: { route },
        cacheTime: Infinity
    })
}
